"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistanceUnit = void 0;
var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit["Metric"] = "Metric";
    DistanceUnit["Imperial"] = "Imperial";
})(DistanceUnit || (exports.DistanceUnit = DistanceUnit = {}));
